<template>
  <!-- <div>
    <el-menu-item v-if="!item.children" :index="item.index">
      <i :class="['iconfont', item.icon]"></i>
      <router-link :to="{name: item.title}">{{item.title}}</router-link>
    </el-menu-item>

    <el-submenu v-else ref="subMenu" :index="item.index">
      <template slot="title">
        <i :class="['iconfont', item.icon]"></i>
        <span slot="title">{{item.title}}</span>
      </template>
      <sidebar-item v-for="child in item.children" :key="child.id" :item="child" class="nest-menu" />
    </el-submenu>
  </div> -->
  <div>
    <el-menu-item
      v-if="item.childrens.length === 0"
      :index="item.id.toString()"
    >
      <i :class="item.iconPath"></i>
      <router-link :to="{ name: item.name }">{{ item.name }}</router-link>
    </el-menu-item>

    <el-submenu v-else ref="subMenu" :index="item.id.toString()">
      <template slot="title">
        <i :class="item.iconPath"></i>
        <span slot="title">{{ item.name }}</span>
      </template>
      <sidebar-item
        v-for="child in item.childrens"
        :key="child.id"
        :item="child"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
export default {
  name: "SidebarItem",
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>
